import { Component, OnInit } from '@angular/core';
import { AuthenticationService, AlertService, CryptoService, GatewayServiceProvider, RequestHelperProvider, StorageServiceProvider } from '../../_services/services';
import utils from './../../utils';
import { Global } from 'src/app/globals';
import * as Sentry from '@sentry/angular';
import { PendingAgreementsConfiguration, ASRAppSettings, StorageKeys } from 'src/app/_constants';
import { AppSettingsServiceProvider } from '../../_services/app-settings.service';
import { PendingAgreementConfig } from 'src/app/_models/booking/pending-agreement-config';
import { HttpClient } from '@angular/common/http';
import { CustomEvents } from '../../_services/custom-events';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/_services/loading.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: true, // Required for Angular 18's new standalone components
  imports: [
    SharedModule,
    MaterialModule
  ]
})
export class HomeComponent implements OnInit {
  isBookAllow: boolean = false;
  isSalesOrderAllow: boolean = false;
  QuoteButtonName: string = "Quote";
  isSameBookingNumber: string = "false";
  isProUser: boolean = false;

  public pendingAgreementConfig: PendingAgreementConfig = {
    pendingAgreementStatus: false,
    emailType: "",
    pendingBookingStatus: "",
    pendingBookingStatusDescription: "",
    pendingPrepayStatus: "",
    pendingPrepayStatusDescription: "",
    pendingOrderStatus: "",
    pendingOrderStatusDescription: "",
    pendingQuoteStatus: "",
    pendingQuoteStatusDescription: "",
    PendingSignatureRequiredStatus: false,
    ButtonQuote: "Quote",
    ButtonBooking: "Book",
    ButtonPrepay: "Prepay",
    SameBookingNumberConfig: false,

  };
  constructor(public cryptoService: CryptoService,
    public alertService: AlertService,
    public globals: Global,
    private router: Router,
    private authenticationService: AuthenticationService,
    private appSetting: AppSettingsServiceProvider,
    private gateway: GatewayServiceProvider,
    private helper: RequestHelperProvider,
    public http: HttpClient,
    private storage: StorageServiceProvider,
    private events: CustomEvents,
    private blockUI: LoadingService) {
    if (this.settingsCheck()) {
      this.router.navigate(['settings']);
    }
    this.getPermissions();
    this.GetPendingAgreementSettings();
    this.getSalesProConfigurations();
  }
  settingsCheck() {
    if (utils.getLocation() == undefined) {
      return true;
    }
    else {
      return false;
    }
  }
  ngOnInit() {
    this.gateway.ValidateAgentSession();

    // var blockLocationValue = (localStorage.getItem('BlockLocation'))? localStorage.getItem('BlockLocation')==='true'? true:false:false;
    localStorage.setItem('BlockLocation', "false");
    this.events.publish("event:blockUnblockLoctionChange");

  }
  logout() {
    this.blockUI.start();
    // this.singnalRService.logOut();
    // this.singnalRService.On('ReturnedlogOutResult', this.onLogOutResponse.bind(this));

    this.authenticationService.releaseAgrisLicense(this.onLogOutResponse, (error) => {
      Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
      console.log(error);
      this.alertService.error(error.Code == 401 ? 'Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.' : error.Message);
      this.blockUI.stop();
    });
  }
  onLogOutResponse = (response: any) => {
    this.blockUI.stop();
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
  getPermissions() {
    let per = localStorage.getItem('UserPermission');
    if (per) {
      let permissions = JSON.parse(this.cryptoService.dencryptString(per));
      permissions.forEach(permission => {
        if (permission.SecurityOption == "KIMPT" && permission.Package == 'ACR' && parseInt(permission.SecurityLevel) > 1) {
          this.isBookAllow = true;
        }
        if (permission.SecurityOption == "PIMPT" && permission.Package == 'INV' && parseInt(permission.SecurityLevel) > 1) {
          this.isSalesOrderAllow = true;
        }
      });
      // console.log(permissions);
    }
  }

  GetPendingAgreementSettings() {

    this.blockUI.start();
    this.appSetting.GetAppSettingsFromASR(ASRAppSettings.PendingAgreementsConfiguration).then((response) => {
      let data = response.TransactionObject;
      if (data.length) {


        let ButtonQuote: any = data.find((x: any) => x.Name == PendingAgreementsConfiguration.ButtonQuote);
        if (ButtonQuote && ButtonQuote.Value) {
          this.pendingAgreementConfig.ButtonQuote = ButtonQuote.Value;
          this.QuoteButtonName = ButtonQuote.Value;
        }
        else {
          this.QuoteButtonName = "Quote";
        }



        let isSameNumber: any = data.find((x: any) => x.Name == PendingAgreementsConfiguration.isSameBookingNumberStatus);
        if (ButtonQuote && ButtonQuote.Value) {
          this.pendingAgreementConfig.SameBookingNumberConfig = isSameNumber.Value;
          this.isSameBookingNumber = isSameNumber.Value === 'true' ? "true" : "false";
          localStorage.setItem('isSameBookingNumber', this.isSameBookingNumber);

        }
        else {
          this.isSameBookingNumber = "false";
        }
      }
      this.blockUI.stop();

    }).catch((error) => {
      if (error)
        this.alertService.error(error.Message);
      this.blockUI.stop();
    })
  }

  getSalesProConfigurations(): Promise<any> {
    let configRemoteURL = utils.GetConfigurationRemoteServer();
    return new Promise((resolve, reject) => {
      this.getModules().then(response => {
        let moduleName = "Sales_Pro";
        let moduleId = response.filter(
          x => x.ModuleName == moduleName)[0].ModuleId;

        // let TenantID = this.storage.getTenantID();
        // let agentId = localStorage.getItem("AgentId");
        let agentId = this.storage.AgentID;
        var data = {
          Authorization: 'Basic YWRtaW46cGFzc3dvcmQx',
        };
        let url = `${configRemoteURL}/ModuleConfigurations?ModuleId=${moduleId}`;
        if (agentId) {
          url += `&Agent=${agentId}`;
        }

        this.http.get(url, { headers: data, })
          .pipe()
          .subscribe((response: any) => {
            if (response) {

              try {
                let value = response[0].ConfigurationValue ? JSON.parse(response[0].ConfigurationValue) : false;
                let remark = value && value.Selected ? 'true' : 'false';
                localStorage.setItem("ProUser", this.cryptoService.encryptString(remark));
                var ProUser: boolean = remark.toLowerCase() === 'true';
                this.isProUser = ProUser;
              }
              catch (ex) {
                //localStorage.setItem("ProUser", this.cryptoService.encryptString("false"));
              }

            }

            resolve(response);
          }, (error) => {
            if (error && error.status == 0) {
              // this.events.publish("event:ShowError", "Please check your network and try again.")
            }
            else { reject(error); }
          }
          );
      });
    });
  };



  getModules(): Promise<any> {
    return new Promise((resolve, reject) => {
      let configRemoteURL = utils.GetConfigurationRemoteServer();
      var data = { Authorization: 'Basic YWRtaW46cGFzc3dvcmQx', };
      let url = `${configRemoteURL}/Modules`;
      let settings = this.storage.get(StorageKeys.Settings);;
      if (settings && settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }
      this.http.get(url,
        { headers: data, }).pipe().subscribe((response) => {
          resolve(response);
        }, (error) => {
          if (error && error.status == 0) {
            console.log("ERRor")
          } else { reject(error); }
        })
    });
  };
}
